<div class="row text-secondary py-2">
  <div class="col" *ngIf="showDate">{{ payment.date | pepDate: locale }}</div>
  <div class="col">{{ type | async }}</div>
  <div class="col-auto text-nowrap pl-0 text-right">{{ payment.amount | pepCurrency: currencyId: locale }}</div>
  <div class="col-auto buttons text-right pl-0">
    <!-- <a href class="px-1" (click)="false" ngbTooltip="{{ payment.date | pepDate: locale }}"><i class="fe fe-calendar"></i></a> -->
    <a href class="px-2 px-sm-1" (click)="expanded = !expanded; false">
      <i class="fe" [class.fe-eye]="!expanded" [class.fe-eye-off]="expanded"></i>
    </a>
    <a href class="px-2 px-sm-1" (click)="onEdit(); false"><i class="fe fe-edit"></i></a>
    <a href class="px-2 px-sm-1" (click)="onDelete(); false"><i class="fe fe-trash text-danger"></i></a>
  </div>
</div>
<div class="row text-secondary pt-0" *ngIf="expanded">
  <div class="col">
    <span *ngIf="note">{{ note }}</span>
    <span *ngIf="!note" class="text-muted">~</span>
  </div>
  <div class="col-auto">
    <div class="row text-right">
      <div class="col" *ngIf="!showDate">
        {{ payment.date | pepDate: locale }}
      </div>
      <ng-container *ngIf="payment.tag">
        <div class="w-100"></div>
        <div class="col">
          {{ payment.tag }}
        </div>
      </ng-container>
    </div>
  </div>

  <hr *ngIf="!last" class="w-100">
</div>